import * as optinalModuleNames from "./modules/utils/names/optionalModuleNames";
import {
    ActionsServiceModuleName,
    ActionStatusModuleName,
    AddressModuleName,
    ANGULAR_CIRCULAR_DATE_TILE_PICKER_MODULE_NAME,
    AngularJsSliderModuleName,
    AngularMaterialTableModuleName,
    AnimateModuleName,
    BranchModuleName,
    BranchServiceModuleName,
    BrandServiceModuleName,
    CalculationsModuleName,
    CampaignsModuleName,
    CampaignsServiceModuleName,
    CardConfigModuleName,
    ChartJsModuleName,
    ContactProfileModuleName,
    ConversionLogModuleName,
    CroppieModuleName,
    CUSTOMER_PROFILE_MODULE_NAME,
    CustomerListModuleName,
    CustomerServiceModuleName,
    CustomersModuleName,
    CustomerSubscriptionModuleName,
    DirectMailerLogsModuleName,
    DragularModuleName,
    DynamicOrderingModuleName,
    EMPLOYEE_PROFILE_SERVICE_MODULE_NAME,
    EmployeeAutocompleteModuleName,
    FilterComponentsModuleName,
    IMAGE_CROPPER_MODULE_NAME,
    InstanceConfigurationModuleName,
    LeadModuleName,
    LeadProfileModuleName,
    LoanArchieModuleName,
    LoggingFundedModuleName,
    LoggingModuleName,
    LqbPricerLogModuleName,
    LqbPricerParamsServiceModuleName,
    ManualImportModuleName,
    MD_COLOR_PICKER_MODULE_NAME,
    MULTICOLUMN_LIST_MODULE_NAME,
    NAVIGATABLE_MODULE_NAME,
    NgMessagesModule,
    OpportunitiesModuleName,
    OpportunitiesServiceModuleName,
    OpportunityActionsModuleName,
    OpportunityFilterModuleName,
    PartnerModuleName,
    PartnerProfileModuleName,
    RedirectModuleName,
    RedirectServiceModuleName,
    SchedulingModuleName,
    SchedulingServiceModuleName,
    SortablePaginationModuleName,
    StatisticModuleName,
    ThemeColourPickerModuleName,
    USERS_MODULE_NAME,
    UserServiceModuleName,
    VAccordionModuleName,
    WebSocketProviderModuleName,
    UserSettingsModuleName
} from "modules/utils/names/optionalModuleNames";
import {
    AngularJsMaterialModuleName,
    LoaderModuleName,
    MainModuleName,
    MainServiceModuleName,
    MaterialConfigurationsModuleName,
    OpportunityNotificationModuleName,
    RouterModuleName,
    UtilsModuleName
} from "modules/utils/names/requiredModulesNames";

export type Module = {};

class ModulesService {


    optionalModuleNames = Object.values(optinalModuleNames);
    private modulesMap: any;

    constructor() {
        this.modulesMap = {};
        this.modulesMap[MainModuleName] = () => import('./modules/main/main.module.ajs')
        this.modulesMap[RouterModuleName] = () => import('./modules/router/RouterModule')
        this.modulesMap[MaterialConfigurationsModuleName] = () => import('./modules/configurations/MaterialConfigurationsModule');
        this.modulesMap[MainServiceModuleName] = () => import('modules/main_service_module/MainServiceModule');

        this.modulesMap[UtilsModuleName] = () => import('modules/utils/utillsModule');

        this.modulesMap[LoaderModuleName] = () => import('modules/loader/loaderModule');

        this.modulesMap[SortablePaginationModuleName] = () => import('./modules/sorable-pagination/sortable-pagination.module');
        this.modulesMap[CustomerSubscriptionModuleName] = () => import('./modules/subscriptions/customer-subscription.module');
        this.modulesMap[ActionsServiceModuleName] = () => import('./modules/opportunity_actions_service/actions-service.module');
        this.modulesMap[RedirectServiceModuleName] = () => import('./modules/redirect_service/RedirectServiceModule');
        this.modulesMap[RedirectModuleName] = () => import('./modules/redirect/RedirectModule');
        this.modulesMap[ManualImportModuleName] = () => import('./modules/manual_import/ManualImportModule');
        this.modulesMap[CampaignsModuleName] = () => import('./modules/campaigns/CampaignsModule');
        this.modulesMap[CardConfigModuleName] = () => import('./modules/card-config/CardConfigModule');

        this.modulesMap[CustomersModuleName] = () => import('./modules/customers/CustomersModule');
        this.modulesMap[CustomerServiceModuleName] = () => import('./modules/customer_service/CustomerServiceModule');
        this.modulesMap[CUSTOMER_PROFILE_MODULE_NAME] = () => import('./modules/customer_profile/CustomerProfileModule');

        this.modulesMap[SchedulingModuleName] = () => import('./modules/scheduling/SchedulingModule');
        this.modulesMap[SchedulingServiceModuleName] = () => import('./modules/scheduling_service/SchedulingServiceModule');
        this.modulesMap[ANGULAR_CIRCULAR_DATE_TILE_PICKER_MODULE_NAME] = () => import('angular-circular-timepicker');

        this.modulesMap[EmployeeAutocompleteModuleName] = () => import('./modules/employee_autocomplete/EmployeeAutocompleteModule');
        this.modulesMap[EMPLOYEE_PROFILE_SERVICE_MODULE_NAME] = () => import('./modules/employee_profile_service/EmployeeProfileServiceModule');

        this.modulesMap[InstanceConfigurationModuleName] = () => import('./modules/brand/instanceConfigurationModule');
        this.modulesMap[NAVIGATABLE_MODULE_NAME] = () => import('./modules/navigatable/navigatableModule');
        this.modulesMap[LoaderModuleName] = () => import('./modules/loader/loaderModule');
        this.modulesMap[StatisticModuleName] = () => import('./modules/statistic/StatisticModule');
        this.modulesMap[CalculationsModuleName] = () => import('./modules/calculations/CalculationsModule');
        this.modulesMap[MULTICOLUMN_LIST_MODULE_NAME] = () => import('./modules/multicolumn_list/multicolumnListModule');
        this.modulesMap[OpportunitiesModuleName] = () => import('./modules/opportunities/opportunitiesModule');
        this.modulesMap[LoggingModuleName] = () => import('./modules/logging_calculation/calculationsLoggingModule');
        this.modulesMap[BranchServiceModuleName] = () => import('./modules/branches_service/BranchesServiceModule');
        this.modulesMap[OpportunityActionsModuleName] = () => import('./modules/opportunity_actions/OpportunityActionsModule');
        this.modulesMap[USERS_MODULE_NAME] = () => import('./modules/users/UsersModule');
        this.modulesMap[LqbPricerLogModuleName] = () => import('./modules/lqb_pricer_log/LqbPricerLogModule');
        this.modulesMap[LoggingFundedModuleName] = () => import('./modules/logging_lqb_funded/lqbFundedLoggingModule');
        this.modulesMap[BrandServiceModuleName] = () => import('./modules/brand_service/BrandServiceModule');
        this.modulesMap[IMAGE_CROPPER_MODULE_NAME] = () => import('./modules/image_cropper/ImageCropperModule');
        this.modulesMap[UserServiceModuleName] = () => import('./modules/users_service/UserServiceModule');
        this.modulesMap[FilterComponentsModuleName] = () => import('./modules/filter_components/FilterComponentsModule');
        this.modulesMap[OpportunityFilterModuleName] = () => import('./modules/opportunities_filter/OpportunityFilterModule');
        this.modulesMap[BranchModuleName] = () => import('./modules/branches/BranchesModule');
        this.modulesMap[OpportunityNotificationModuleName] = () => import('./modules/opportunities_notification/opportunityNotificationModule');
        this.modulesMap[OpportunitiesServiceModuleName] = () => import('./modules/opportunities_service/opportunityServiceModule');
        this.modulesMap[LqbPricerParamsServiceModuleName] = () => import('./modules/lqb_pricer_parameters_service/LqbPricerParametersServiceModule');
        this.modulesMap[ThemeColourPickerModuleName] = () => import('./modules/theme_colour_select/ThemeColourSelectModule');
        this.modulesMap[AddressModuleName] = () => import('./modules/address/address.module');
        this.modulesMap[CustomerListModuleName] = () => import('./modules/customer-list/customer.list.module');
        this.modulesMap[DynamicOrderingModuleName] = () => import('./modules/dynamic-ordering/dynamic-odering.module');
        this.modulesMap[WebSocketProviderModuleName] = () => import('./modules/websocket_service/websocket-provider.module');
        this.modulesMap[CampaignsServiceModuleName] = () => import('./modules/campaigns_service/CampaignsServiceModule');
        this.modulesMap[ActionStatusModuleName] = () => import('./modules/action_status/action_status.module');
        this.modulesMap[DirectMailerLogsModuleName] = () => import('./modules/direct_mailer_logs/DirectMailerLogsModule');

        this.modulesMap[ConversionLogModuleName] = () => import('./modules/conversion_log/ConversionLogModule');

        this.modulesMap[LoanArchieModuleName] = () => import('./modules/loan_archive/LoanArchieModule');

        this.modulesMap[ContactProfileModuleName] = () => import('./modules/contact/ContactProfileModule');
        this.modulesMap[LeadModuleName] = () => import('./modules/lead/LeadModule');
        this.modulesMap[LeadProfileModuleName] = () => import('./modules/lead/LeadProfileModule');
        this.modulesMap[PartnerModuleName] = () => import('./modules/partner/PartnerModule');
        this.modulesMap[PartnerProfileModuleName] = () => import('./modules/partner/PartnerProfileModule');
        this.modulesMap[UserSettingsModuleName] = () => import("./modules/user_settings/UserSettingsModule")

        // EXTERNAL LIBRARIES MODULES IMPORTS
        this.modulesMap[NgMessagesModule] = () => import('angular-messages');
        this.modulesMap[VAccordionModuleName] = () => import('v-accordion');
        this.modulesMap[AnimateModuleName] = () => import('angular-animate');
        this.modulesMap[AngularJsMaterialModuleName] = () => import('angular-material');
        this.modulesMap[AngularMaterialTableModuleName] = () => import('angular-material-data-table');
        this.modulesMap[DragularModuleName] = () => import('dragular');
        this.modulesMap[MD_COLOR_PICKER_MODULE_NAME] = () => import('md-color-picker');
        this.modulesMap[ChartJsModuleName] = () => import('chart.js/dist/Chart.bundle.min');
        this.modulesMap[CroppieModuleName] = () => import('croppie/croppie.min');
        this.modulesMap[AngularJsSliderModuleName] = () => import('angularjs-slider');
        this.modulesMap[DragularModuleName] = () => import ('dragular');
    }

    public importAllModules(dependentModulesNames: string[]): Promise<Module> {
        return Promise.all(dependentModulesNames.map(this.importModule));
    }

    importModule = (moduleName): Promise<any> => {
        let moduleResolver = this.modulesMap[moduleName];
        if (moduleResolver) {
            console.info('Importing module ' + moduleName)
            return moduleResolver();
        } else {
            console.warn("Failed To Load Module " + moduleName)
        }
    };
}

export const ModulesServiceInstance = new ModulesService();